import React from 'react';
import { useSelector } from 'react-redux';
import { SwiperSlide } from 'swiper/react';
import './GridPageStripGamesDesignHorizontalMix.css';
import { ThumbnailInLoadingState } from '../../GameThumbnails/ThumbnailInLoadingState';
import { GridPageStripGamesSwiper } from '../GridPageStripGamesSwiper';
import { ImageType } from '../../../../../shared/src/components/Image';

const renderPreloadThumbnails = () => {
    const gamesToRender = (new Array(30)).fill(undefined);
    const gamesCount = gamesToRender.length;
    const result = [];

    for (let i = 0; i < gamesCount; i += 3) {
        result.push((
            <SwiperSlide key={i}>
                <ThumbnailInLoadingState />
            </SwiperSlide>
        ));

        const addSecond = i + 1 < gamesCount;
        if (addSecond) {
            const addThird = i + 2 < gamesCount;

            result.push((
                <SwiperSlide key={i + 1}>
                    <ThumbnailInLoadingState />
                    {addThird && <ThumbnailInLoadingState />}
                </SwiperSlide>
            ));
        }
    }

    return result;
};

const renderGamesThumbnails = (gamesToRender, renderFn) => {
    const renderedGames = gamesToRender.reduce((result, gameId) => {
        const imageType = result.length % 3 === 0
            ? ImageType.VERTICAL_RECTANGLE
            : ImageType.DEFAULT;
        const item = renderFn(gameId, {
            imageType,
        });
        if (item) {
            result.push(item);
        }

        return result;
    }, []);

    const gamesCount = renderedGames.length;
    const result = [];

    for (let i = 0; i < gamesCount; i += 3) {
        result.push((
            <SwiperSlide key={i}>
                {renderedGames[i]}
            </SwiperSlide>
        ));

        const addSecond = i + 1 < gamesCount;
        if (addSecond) {
            const addThird = i + 2 < gamesCount;
            const content2 = renderedGames[i + 1];

            const content3 = addThird
                ? renderedGames[i + 2]
                : (<div className="casino-thumbnail"></div>);

            result.push((
                <SwiperSlide key={i + 1}>
                    {content2}
                    {content3}
                </SwiperSlide>
            ));
        }
    }

    return result;
};

export const GridPageStripGamesDesignHorizontalMix = ({ games, renderCasinoThumbnailFn, strip }) => {
    const gamesToRender = games.slice(0, 50); // limit games number to optimize performance
    const { platformGamesReady } = useSelector((state) => state.app);
    const itemsToRender = platformGamesReady
        ? renderGamesThumbnails(gamesToRender, renderCasinoThumbnailFn)
        : renderPreloadThumbnails();

    return (
        <GridPageStripGamesSwiper
            wrapperClassName="grid-pages-horizontal-mix"
            strip={strip}
        >
            {itemsToRender}
        </GridPageStripGamesSwiper>
    );
};
